import { TrendingUp, TrendingDown } from 'lucide-react';

export const StockTicker = () => {
  const tickerItems = [
    { name: 'Biryani', change: '+12%', up: true },
    { name: 'Pizza', change: '-2%', up: false },
    { name: 'Butter Chicken', change: '+8%', up: true },
    { name: 'Dosa', change: '+5%', up: true },
    { name: 'Paneer Tikka', change: '-1%', up: false },
    { name: 'Vada Pav', change: '+15%', up: true },
    { name: 'Chole Bhature', change: '+3%', up: true },
    { name: 'Pav Bhaji', change: '-4%', up: false },
    { name: 'Samosa', change: '+7%', up: true },
    { name: 'Idli', change: '+2%', up: true },
  ];

  // Duplicate for seamless loop
  const allItems = [...tickerItems, ...tickerItems];

  return (
    <div className="ticker-container" data-testid="stock-ticker">
      <div className="animate-ticker inline-flex">
        {allItems.map((item, index) => (
          <div key={index} className="ticker-item">
            <span className="font-semibold mr-2">{item.name}</span>
            <span className={`flex items-center gap-1 ${item.up ? 'text-green-400' : 'text-red-400'}`}>
              {item.up ? (
                <TrendingUp className="w-4 h-4" />
              ) : (
                <TrendingDown className="w-4 h-4" />
              )}
              {item.change}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};
